import { observer } from "mobx-react-lite";
import Layout from "../../components/layout/Layout";
import { useStore } from "../../stores/root-store-context";
import {
  Button,
  Flex,
  Form,
  Input,
  Modal,
  Spin,
  Space,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { SkillLevelName, SkillLevelNameColor } from "../../helpers/skills";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import UserComponent from "./UserComponent";
import { useReactToPrint } from "react-to-print";
import { Employee } from "../../models/Employee";

const Account = observer(() => {
  const { applicationStore, employeesStore, projectsStore } = useStore();
  const navigate = useNavigate();
  const userPage = useRef(null);
  const { id } = useParams();
  const { t } = useTranslation();

  const [isModalPassword, setIsModalPassword] = useState(false);
  const [isModalEmail, setIsModalEmail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<Employee>();
  // const [history, setHistory] = useState<HistoryItem[]>([]);
  const profileRef = useRef(null);

  const pdfRef = useRef<HTMLDivElement>(null);
  
  const showModalPassword = () => {
    setIsModalPassword(true);
  };

  const handleOkPassword = () => {
    setIsModalPassword(false);
  };

  const handleCancelPassword = () => {
    setIsModalPassword(false);
  };

  const showModalEmail = () => {
    setIsModalEmail(true);
  };

  const handleOkEmail = () => {
    setIsModalEmail(false);
  };

  const handleCancelEmail = () => {
    setIsModalEmail(false);
  };
  
  function ParseToJson(str: string): any[] {
    try {
      return JSON.parse(str);
    } catch (e) {
      return [];
    }
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      employeesStore.ApiStore.EmployeesApiClient.getUserById(id)
        .then(async (result) => {
          console.log("result");
          console.log(result);
          setUser(result);

          // if(projectsStore.projects?.length === 0){
          //   await projectsStore.getAll()
          // }
          // await employeesStore.ApiStore.EmployeesApiClient.getHistoryByUser(id).then(res => {
          //   setHistory(res)
          // });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      navigate("/404");
    }
    // employeesStore.ApiStore.EmployeesApiClient.getUserById(id);
    console.log(id);
  }, [id]);

  const handlePrint = useReactToPrint({
    content: () => profileRef.current,
    documentTitle: 'Employee Profile',
    pageStyle: `@page { size: A4; margin: 0mm }`,
  });


  const generatePDF = async (user: Employee) => {
    // Your HTML content as a string
    const experienceList = ParseToJson(user.experience)
        const currentCompanyExperiences = experienceList.filter(exp =>
            exp.Project && exp.Company === applicationStore.company?.Title
        );

        const otherExperiences = experienceList.filter(exp =>
            !exp.Project || exp.Company !== applicationStore.company?.Title
        );

        const getExperience = (item: any) => {
          const dates = (item.StartDate ? dayjs(item.StartDate).format("YYYY-MM-DD") : "") + " - " +
          ((item.EndDate === "0001-01-01" || item.EndDate === "1901-01-01" || !item.EndDate)
              ? t("PresentTime")
              : dayjs(item.EndDate).format("YYYY-MM-DD"));

            return `
            <div
                        style="position: relative; background-color: rgb(255, 255, 255); padding: 16px; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px; overflow: hidden;">
                        <h3 style="margin-bottom: 8px; font-weight: bold; color: rgb(42, 42, 42); font-size: 16px;">
                            ${t("Company")} ${item.Company}</h3>
                        <div style="margin-bottom: 8px; color: rgb(74, 74, 74); font-size: 14px;">${item.Project ? t("Project") + ": " + item.Project : ""}Проект: </div>
                        <div style="margin-bottom: 8px; color: rgb(74, 74, 74); font-size: 14px;">${t("Position")}: ${item.Position}</div>
                        <div style="color: rgb(140, 140, 140); font-size: 14px;"><span role="img" aria-label="calendar"
                                class="anticon anticon-calendar"
                                style="margin-right: 8px; color: rgb(250, 173, 20);"><svg viewBox="64 64 896 896"
                                    focusable="false" data-icon="calendar" width="1em" height="1em" fill="currentColor"
                                    aria-hidden="true">
                                    <path
                                        d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z">
                                    </path>
                                </svg></span>${dates}</div>
                        <div class="ant-divider css-dev-only-do-not-override-1kb7w7o ant-divider-horizontal"
                            role="separator" style="margin: 12px 0px; border-color: rgb(232, 232, 232);"></div>
                        <div
                            style="background-color: rgb(230, 247, 255); color: rgb(24, 144, 255); padding: 8px 12px; border-radius: 4px; font-weight: bold; font-size: 14px; text-align: left;">
                            
                            <div style="width: 700px;white-space: pre-wrap;word-break: break-word; font-size: .875em; font-size: 14px;font-weight: 400; font-family: SFMono-Regular, Menlo, Monaco, Consolas;">${item.Description}</div>
                            </div>
                    </div>
                    `
        }

        const htmlContent = `
      <html>
        <head>
          <title>Profile PDF</title>
          <style>
          *{
          text-transform: none;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";}
            /*! CSS Used from: Embedded */
.anticon{display:inline-flex;align-items:center;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-0.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.anticon > *{line-height:1;}
.anticon svg{display:inline-block;}
.anticon::before{display:none;}
/*! CSS Used from: Embedded */

:where(.css-dev-only-do-not-override-1kb7w7o) a:focus{text-decoration:none;outline:0;}
/*! CSS Used from: Embedded */
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-size:14px;box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn::before,:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn::after{box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn{outline:none;position:relative;display:inline-flex;gap:8px;align-items:center;justify-content:center;font-weight:400;white-space:nowrap;text-align:center;background-image:none;background:transparent;border:1px solid transparent;cursor:pointer;transition:all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);user-select:none;touch-action:manipulation;color:rgba(0, 0, 0, 0.88);}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn:disabled>*{pointer-events:none;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn{font-size:14px;line-height:1.5714285714285714;height:32px;padding:4px 15px;border-radius:0;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn.ant-btn-circle.ant-btn{min-width:32px;padding-inline-start:0;padding-inline-end:0;border-radius:50%;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn-text:not(:disabled):not(.ant-btn-disabled):hover{color:rgba(0, 0, 0, 0.88);background:rgba(0, 0, 0, 0.06);}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn-text:not(:disabled):not(.ant-btn-disabled):active{color:rgba(0, 0, 0, 0.88);background:rgba(0, 0, 0, 0.15);}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-btn-text:disabled{cursor:not-allowed;color:rgba(0, 0, 0, 0.25);}
/*! CSS Used from: Embedded */
:where(.css-dev-only-do-not-override-1kb7w7o)[class^="ant-image"]{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-size:14px;box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o)[class^="ant-image"]::before,:where(.css-dev-only-do-not-override-1kb7w7o)[class^="ant-image"]::after{box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o)[class^="ant-image"] [class^="ant-image"]{box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o)[class^="ant-image"] [class^="ant-image"]::before,:where(.css-dev-only-do-not-override-1kb7w7o)[class^="ant-image"] [class^="ant-image"]::after{box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-image{position:relative;display:inline-block;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-image .ant-image-img{width:100%;height:auto;vertical-align:middle;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-image .ant-image-mask{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;background:rgba(0, 0, 0, 0.5);cursor:pointer;opacity:0;transition:opacity 0.3s;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-image .ant-image-mask .ant-image-mask-info{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:0 4px;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-image .ant-image-mask .ant-image-mask-info .anticon{margin-inline-end:4px;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-image .ant-image-mask .ant-image-mask-info .anticon svg{vertical-align:baseline;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-image .ant-image-mask:hover{opacity:1;}
/*! CSS Used from: Embedded */
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex{display:flex;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex-vertical{flex-direction:column;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex:empty{display:none;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex-wrap-wrap{flex-wrap:wrap;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex-align-center{align-items:center;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex-align-stretch{align-items:stretch;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex-justify-center{justify-content:center;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-flex-justify-space-between{justify-content:space-between;}
/*! CSS Used from: Embedded */
:where(.css-dev-only-do-not-override-1kb7w7o).ant-tag{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-size:14px;box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-tag::before,:where(.css-dev-only-do-not-override-1kb7w7o).ant-tag::after{box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-tag{box-sizing:border-box;margin:0;padding:0;color:rgba(0, 0, 0, 0.88);font-size:12px;line-height:20px;list-style:none;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';display:inline-block;height:auto;margin-inline-end:8px;padding-inline:7px;white-space:nowrap;background:#fafafa;border:1px solid #d9d9d9;border-radius:4px;opacity:1;transition:all 0.2s;text-align:start;position:relative;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-tag{color:rgba(0, 0, 0, 0.88);}
/*! CSS Used from: Embedded */
:where(.css-dev-only-do-not-override-1kb7w7o).ant-typography{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-size:14px;box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-typography::before,:where(.css-dev-only-do-not-override-1kb7w7o).ant-typography::after{box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-typography{color:rgba(0, 0, 0, 0.88);word-break:break-word;line-height:1.5714285714285714;}
h4:where(.css-dev-only-do-not-override-1kb7w7o).ant-typography{margin-bottom:0.5em;color:rgba(0, 0, 0, 0.88);font-weight:600;font-size:20px;line-height:1.4;}
/*! CSS Used from: Embedded */
:where(.css-dev-only-do-not-override-1kb7w7o).ant-divider{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';font-size:14px;box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-divider::before,:where(.css-dev-only-do-not-override-1kb7w7o).ant-divider::after{box-sizing:border-box;}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-divider{box-sizing:border-box;margin:0;padding:0;color:rgba(0, 0, 0, 0.88);font-size:14px;line-height:1.5714285714285714;list-style:none;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';border-block-start:1px solid rgba(5, 5, 5, 0.06);}
:where(.css-dev-only-do-not-override-1kb7w7o).ant-divider-horizontal{display:flex;clear:both;width:100%;min-width:100%;margin:24px 0;}
/*! CSS Used from: Embedded */
:where(.css-dev-only-do-not-override-1kb7w7o).ant-tag.ant-tag-blue{color:#0958d9;background:#e6f4ff;border-color:#91caff;}
/*! CSS Used from: Embedded */
.anticon{display:inline-flex;align-items:center;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-0.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.anticon >*{line-height:1;}
.anticon svg{display:inline-block;}
/*! CSS Used from: Embedded */
.anticon{display:inline-flex;align-items:center;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-0.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.anticon >*{line-height:1;}
.anticon svg{display:inline-block;}
/*! CSS Used from: Embedded */
*,::after,::before{box-sizing:border-box;}


p{margin-top:0;margin-bottom:1rem;}

img,svg{vertical-align:middle;}
button{border-radius:0;}
button:focus:not(:focus-visible){outline:0;}
button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
button{text-transform:none;}
[type=button],button{-webkit-appearance:button;}
[type=button]:not(:disabled),button:not(:disabled){cursor:pointer;}
.container{--bs-gutter-x:1.5rem;--bs-gutter-y:0;width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-right:auto;margin-left:auto;}
@media (min-width:576px){
.container{max-width:540px;}
}
@media (min-width:768px){
.container{max-width:720px;}
}
@media (min-width:992px){
.container{max-width:960px;}
}
@media (min-width:1200px){
.container{max-width:1140px;}
}
@media (min-width:1400px){
.container{max-width:1314px;}
}
/*! CSS Used from: Embedded */
.fa{font-family:var(--fa-style-family,"Font Awesome 6 Pro");font-weight:var(--fa-style,900);}
.fa{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:var(--fa-display,inline-block);font-style:normal;font-variant:normal;line-height:1;text-rendering:auto;}
.fa-pencil:before{content:"\f303";}
/*! CSS Used from: Embedded */
button{border:none;background-color:transparent;padding:0;}
h3,h4,h6{font-family:var(--heading-font);margin:0px;padding:0;color:var(--header);text-transform:capitalize;transition:all 0.4s ease-in-out;}
h3{font-size:22px;font-weight:600;}
@media (max-width: 575px){
h3{font-size:20px;}
}
h4{font-size:20px;font-weight:600;line-height:130%;}
h6{font-size:16px;font-weight:600;line-height:145%;}
p{margin:0px;transition:all 0.4s ease-in-out;}
span{margin:0px;transition:all 0.4s ease-in-out;}
::-webkit-scrollbar{width:4px;height:4px;}
::-webkit-scrollbar-track{box-shadow:inset 0 0 5px var(--theme);border-radius:5px;}
::-webkit-scrollbar-thumb{background:var(--theme);border-radius:10px;}
          </style>
        </head>
        <body>
          <div class="container ant-flex css-dev-only-do-not-override-1kb7w7o ant-flex-align-stretch ant-flex-vertical"
    style="margin-top: 20px; margin-bottom: 20px; gap: 10px;">
    <div class="company-logo" style="/* display: none; */"><img
            src="${applicationStore.company?.LogoId ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/${applicationStore.company?.LogoId}` : "/assets/logo_black.png"}" alt="logo-img"
            height="60"></div>
    <div class="ant-flex css-dev-only-do-not-override-1kb7w7o">
        <div class="ant-flex css-dev-only-do-not-override-1kb7w7o ant-flex-align-center ant-flex-vertical"
            style="flex: 1 1 300px; border: 1px solid rgb(245, 244, 244); padding: 10px; gap: 10px;">
            <div class="ant-image css-dev-only-do-not-override-1kb7w7o" style="width: 160px; height: 160px;"><img
                    class="ant-image-img css-dev-only-do-not-override-1kb7w7o"
                    src="${user?.photoId
                ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/ar_1:1,c_fill,w_160,h_160/${user?.photoId}`
                : `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/ar_1:1,c_fill/z03w7hlsy8hcoic9dlcn`}"

                    width="160" height="160" style="height: 160px; border-radius: 50%; object-fit: cover;">
                <div class="ant-image-mask">
                    <div class="ant-image-mask-info"><span role="img" aria-label="eye" class="anticon anticon-eye"><svg
                                viewBox="64 64 896 896" focusable="false" data-icon="eye" width="1em" height="1em"
                                fill="currentColor" aria-hidden="true">
                                <path
                                    d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z">
                                </path>
                            </svg></span>Попередній перегляд</div>
                </div>
            </div><span class="ant-tag ant-tag-blue css-dev-only-do-not-override-1kb7w7o"
                style="background-color: lightgray; text-align: center;">
                <div style="font-weight: bold;">${applicationStore.jobTitles.find(el => el.id === user?.jobTitleId)?.title || ""}</div>
            </span><span style="font-size: 24px;">${`${user?.firstName} ${user?.lastName}`}</span>
            <div style="text-align: left;"><a href="mailto:${user?.email}"
                    style="display: block; margin-bottom: 8px;"><span role="img" aria-label="mail"
                        class="anticon anticon-mail"><svg viewBox="64 64 896 896" focusable="false" data-icon="mail"
                            width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path
                                d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z">
                            </path>
                        </svg></span> ${user?.email}</a><a href="tel://${user?.phoneNumber}"
                    style="display: block; margin-bottom: 8px;"><span role="img" aria-label="mobile"
                        class="anticon anticon-mobile"><svg viewBox="64 64 896 896" focusable="false" data-icon="mobile"
                            width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path
                                d="M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z">
                            </path>
                        </svg></span> ${user?.phoneNumber}</a>
                        
                        ${user?.skype ? `<a href="${user?.skype}?call"
                    style="display: block; margin-bottom: 8px;">
                    
                    <span role="img" aria-label="skype"
                        class="anticon anticon-skype"><svg viewBox="64 64 896 896" focusable="false" data-icon="skype"
                            width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path
                                d="M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 01-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 01-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0171.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z">
                            </path>
                        </svg></span> ${user?.skype || ""}</a>`:""}
                <div style="display: block; margin-bottom: 8px;"><span role="img" aria-label="gift"
                        class="anticon anticon-gift"><svg viewBox="64 64 896 896" focusable="false" data-icon="gift"
                            width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path
                                d="M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z">
                            </path>
                        </svg></span> ${dayjs(user?.birthDay)?.format("DD MMMM")} </div>
            </div>
            <h6>${t("user.MySkills")}</h6>
            <div class="ant-flex css-dev-only-do-not-override-1kb7w7o ant-flex-wrap-wrap ant-flex-justify-center"
                style="max-width: 300px; gap: 10px;">
                ${user?.userSkills?.map((el, index) => {
                    return (
                        `<span
                    class="ant-tag ant-tag-blue css-dev-only-do-not-override-1kb7w7o"
                    style="background-color: ${SkillLevelNameColor[parseInt(el.skillLevel)]}; text-align: center; ${el.isConfirmed ? 'padding-right: 25px':""}">
                    <div style="font-weight: bold;">${el.skill.title}</div>
                    <div>${SkillLevelName[parseInt(el.skillLevel)]}</div>
                    <div style="font-weight: bold;">${el.experienceYears} ${t("years")}</div>
                    ${el.isConfirmed ? 
                    `<span role="img" aria-label="check-circle" class="anticon anticon-check-circle" style="position: absolute; right: 3px; font-size: 18px; top: 20%; transform: translateY(-50%); color: rgb(0, 128, 0);"><svg viewBox="64 64 896 896" focusable="false" data-icon="check-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path></svg></span>
                    `
                    :""}
                    </span>`
                    )
                }).join("")}
                </div>
        </div>
        <div class="ant-flex css-dev-only-do-not-override-1kb7w7o ant-flex-align-stretch ant-flex-vertical"
            style="flex: 1 1 600px;">
            <div
                style="background-color: rgb(255, 255, 255); padding: 16px; border-radius: 8px; margin-bottom: 16px; box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px; width: 100%;">
                <div class="ant-flex css-dev-only-do-not-override-1kb7w7o ant-flex-justify-space-between">
                    <h4 class="ant-typography css-dev-only-do-not-override-1kb7w7o"
                        style="margin-bottom: 8px; color: rgb(42, 42, 42);">${t("user.AboutMe")}</h4><button type="button"
                        class="ant-btn css-dev-only-do-not-override-1kb7w7o ant-btn-circle ant-btn-text"></button>
                </div>
                <div>
                    <p style="margin-bottom: 20px;">${user?.aboutMe}</p>
                </div>
            </div>
            <div
                style="background-color: rgb(255, 255, 255); padding: 16px; border-radius: 8px; margin-bottom: 16px; box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px; width: 100%;">
                <div class="ant-flex css-dev-only-do-not-override-1kb7w7o ant-flex-justify-space-between">
                    <h4 class="ant-typography css-dev-only-do-not-override-1kb7w7o"
                        style="margin-bottom: 8px; color: rgb(42, 42, 42);">${t("user.MyHobby")}</h4><button type="button"
                        class="ant-btn css-dev-only-do-not-override-1kb7w7o ant-btn-circle ant-btn-text"></button>
                </div>
                <div>
                    <p style="margin-bottom: 20px;">${user?.hobby}</p>
                </div>
            </div>
            <div
                style="padding: 20px; box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px; border-radius: 8px; width: 100%; margin-bottom: 16px;">
              ${user.education.length>5?`<h3 style="margin-bottom: 20px; color: rgb(51, 51, 51);">${t("user.Education")}</h3>`:''}
                <div style="display: flex; flex-direction: column; gap: 16px;">
                    ${ParseToJson(user.education).map((item, index) => {
                    return (
                        `<div
                        style="position: relative; background-color: rgb(255, 255, 255); padding: 16px; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px; overflow: hidden;">
                        <h3 style="margin-bottom: 8px; font-weight: bold; color: rgb(42, 42, 42); font-size: 16px;">
                           ${item.University}</h3>
                        <div style="margin-bottom: 8px; color: rgb(74, 74, 74); font-size: 14px;"><span role="img"
                                aria-label="book" class="anticon anticon-book"
                                style="margin-right: 8px; color: rgb(24, 144, 255);"><svg viewBox="64 64 896 896"
                                    focusable="false" data-icon="book" width="1em" height="1em" fill="currentColor"
                                    aria-hidden="true">
                                    <path
                                        d="M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z">
                                    </path>
                                </svg></span>${item.Degree ? ParseToJson(item.Degree).join(', ') : ''}</div>
                        <div style="margin-bottom: 8px; color: rgb(108, 108, 108); font-size: 14px;"><span role="img"
                                aria-label="environment" class="anticon anticon-environment"
                                style="margin-right: 8px; color: rgb(82, 196, 26);"><svg viewBox="64 64 896 896"
                                    focusable="false" data-icon="environment" width="1em" height="1em"
                                    fill="currentColor" aria-hidden="true">
                                    <path
                                        d="M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z">
                                    </path>
                                </svg></span>${item.City}, ${item.Country}</div>
                        <div style="color: rgb(140, 140, 140); font-size: 14px;"><span role="img" aria-label="calendar"
                                class="anticon anticon-calendar"
                                style="margin-right: 8px; color: rgb(250, 173, 20);"><svg viewBox="64 64 896 896"
                                    focusable="false" data-icon="calendar" width="1em" height="1em" fill="currentColor"
                                    aria-hidden="true">
                                    <path
                                        d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z">
                                    </path>
                                </svg></span>${item.StartDate ? dayjs(item.StartDate).format("YYYY-MM-DD") : ""} - ${item.EndDate ? dayjs(item.EndDate).format("YYYY-MM-DD") : ""}</div>
                        <div class="ant-divider css-dev-only-do-not-override-1kb7w7o ant-divider-horizontal"
                            role="separator" style="margin: 12px 0px; border-color: rgb(232, 232, 232);"></div>
                        <div
                            style="background-color: rgb(230, 247, 255); color: rgb(24, 144, 255); padding: 8px 12px; border-radius: 4px; font-weight: bold; font-size: 14px; text-align: left;">
<div style="width: 700px;white-space: pre-wrap;word-break: break-word; font-size: .875em; font-size: 14px;font-weight: 400; font-family: SFMono-Regular, Menlo, Monaco, Consolas;">${item.Profession}</div>
                            </div>
                    </div>`
                    )
                }).join("")
            }
                </div>
            </div>
            <div
                style="padding: 20px; box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px; border-radius: 8px; width: 100%; margin-bottom: 16px;">
                <h3 style="margin-bottom: 20px; color: rgb(51, 51, 51);">${t("Experience")} ${t("in")} ${applicationStore.company?.Title}</h3>
                <div style="display: flex; flex-direction: column; gap: 16px;">
                     ${currentCompanyExperiences.sort((a, b) => dayjs(a.StartDate).isBefore(dayjs(b.StartDate)) ? 1 : -1).map((item, index) => {
                return getExperience(item)
            }).join("")}
                    
                </div>
                <h3 style="margin-bottom: 20px; color: rgb(51, 51, 51);">${t("Experience")} ${t("in")} ${t("OtherCompanies")}</h3>
                <div style="display: flex; flex-direction: column; gap: 16px;">
                    ${otherExperiences.sort((a, b) => dayjs(a.StartDate).isBefore(dayjs(b.StartDate)) ? 1 : -1).map((item, index) => {
                return getExperience(item)
            }).join("")}
                    
                </div>
            </div>
        </div>
    </div>
</div>
        </body>
      </html>
    `;

    const hiddenDiv = document.createElement("div");
    hiddenDiv.innerHTML = htmlContent; 
    hiddenDiv.style.position = "absolute";
    hiddenDiv.style.left = "-9999px";
    hiddenDiv.style.width = "1300px";  
    hiddenDiv.style.minHeight = "1123px"; 
    hiddenDiv.style.background = "white"; 
    document.body.appendChild(hiddenDiv);

    // Convert HTML to Canvas
    const canvas = await html2canvas(hiddenDiv, { scale: 2, useCORS: true });
    document.body.removeChild(hiddenDiv); // Remove after rendering

    // Generate PDF
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    
    const canvasAspectRatio = canvas.width / canvas.height;
    const imgHeight = imgWidth / canvasAspectRatio; // Масштабування під A4
    
    // Якщо висота зображення більше сторінки PDF, ділимо на частини
    let position = 0;
    
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    
    if (imgHeight > pageHeight) {
      let heightLeft = imgHeight - pageHeight;
    
      while (heightLeft > 0) {
        position = position - pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
    }
    
    // Збереження PDF
    pdf.save(`${user.firstName} ${user.lastName}.pdf`);
  };


  return (
    <>
      <Layout headerStyle={1} footerStyle={2}>
        <div  className="profiles-font-settings">
        <Spin spinning={loading} style={{ minHeight: 600 }}>
          <Flex className="container" gap={10} style={{ marginTop: 20, display: "flex", justifyContent: "space-between" }}>
            <Button
              style={{ float: "left", borderRadius: 0 }}
              onClick={() => {
                navigate(-1);
              }}
            >
               {t("back")}
            </Button>
            <Space>
              <Button type="primary" onClick={async () => {
                //TODO move to BackEnd C#
                if (userPage.current && user) {
                  generatePDF(user)
                   setLoading(true);
                  setLoading(false

                  );
                }
              }}>{t("DownloadResume")}</Button>
            </Space>
          </Flex>
          <Flex
            className="container"
            gap={10}
            style={{ marginTop: 20, marginBottom: 20 }}
            vertical
            ref={userPage}
          >
            <div className="company-logo" style={{ display: "none" }}>
              {applicationStore.company?.LogoId ?
                <img src={`${applicationStore?.siteConfig?.baseCloudinary}/image/upload/${applicationStore.company?.LogoId}`} alt="logo-img" height={60} />
                :
                <img src="/assets/logo_black.png" alt="logo-img" height={60} />
              }
            </div>
            {user && <UserComponent user={user} />}
          </Flex>
        </Spin>
        </div>
        <Modal
          title={t("enterNewEmail")}
          open={isModalEmail}
          onOk={handleOkEmail}
          onCancel={handleCancelEmail}
        >
          <Form>
            <Form.Item<any>
              name="Email"
              style={{ width: "100%" }}
              rules={[{ required: true }]}
            >
              <Input placeholder={t("emailPlaceholder")} pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$" />
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title={t("enterNewPassword")}
          open={isModalPassword}
          onOk={handleOkPassword}
          onCancel={handleCancelPassword}
        >
          <Form>
            <Form.Item<any>
              name="Password"
              style={{ width: "100%" }}
              rules={[{ required: true }]}
            >
              <Input placeholder={t("passwordPlaceholder")} type="password" />
            </Form.Item>
          </Form>
        </Modal>
      </Layout>
    </>
  );
});
export default Account;
